import React from 'react';
import styled from 'styled-components';
import SvgIcon from '@material-ui/core/SvgIcon';
import { useCookies } from 'react-cookie';
import Badge from '../../../../Icons/Badge';
import { CookieNames } from '../../../../../../config';

const Root = styled.div.withConfig({ componentId: 'sc-a0503-0' })`
  position: relative;
  height: 24px;
`;

export default () => {
  const [cookies] = useCookies([CookieNames.INSURANCE_BADGE]);

  const Icon = (
    <SvgIcon>
      <svg
        fill="none"
        height="24"
        viewBox="0 0 24 24"
        width="24"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M2 11.45C2 18.6 11.4511 23 12.0033 23C12.5555 23 21.9999 18.6 21.9999 11.45C21.9999 9.81059 22 6.46897 22 5.00909C22 4.58324 21.7332 4.20741 21.3307 4.06857C19.4991 3.43691 14.4009 1.6899 12.286 1.08043C12.0981 1.02629 11.9054 1.03091 11.7196 1.09173C10.3815 1.52966 4.62728 3.41392 2.64813 4.07789C2.25479 4.20985 2 4.57225 2 4.98714C2 6.43522 2 9.80232 2 11.45Z"
          stroke="currentColor"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1.5"
        />
        <path
          d="M8 11L11 14L16.5 8.5"
          stroke="currentColor"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1.5"
        />
      </svg>
    </SvgIcon>
  );

  if (!cookies[CookieNames.INSURANCE_BADGE]) {
    return (
      <Root>
        {!cookies[CookieNames.INSURANCE_BADGE] && <Badge />}
        {Icon}
      </Root>
    );
  }
  return Icon;
};
